/**
 * Business events for the PostHog snippet already installed in theme.liquid.
 * Does not load PostHog, and does not read form text, email, phone, or payment data.
 */
(function amadaPosthogEvents() {
  if (window.__amadaPosthogEvents) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  window.__amadaPosthogEvents = true;

  const FEE_HANDLE = 'amada-hand-engraving';
  const ADD_CONTEXT_MS = 10000;
  let pendingAdd = null;
  let productViewed = false;
  let lastCalendlyAt = 0;

  function analyticsAllowed() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      return Boolean(privacy && privacy.analyticsProcessingAllowed && privacy.analyticsProcessingAllowed());
    } catch (error) {
      return false;
    }
  }

  function capture(eventName, properties) {
    if (!analyticsAllowed()) return;
    if (!window.posthog || typeof window.posthog.capture !== 'function') return;
    const payload = {};
    Object.keys(properties || {}).forEach((key) => {
      const value = properties[key];
      if (value === undefined || value === null || value === '') return;
      payload[key] = value;
    });
    window.posthog.capture(eventName, payload);
  }

  function pageContext() {
    return {
      page_url: window.location.href,
      page_path: window.location.pathname,
    };
  }

  function readProduct() {
    const node = document.getElementById('amada-posthog-product');
    if (!node) return null;
    try {
      const data = JSON.parse(node.textContent || '');
      return data && typeof data === 'object' ? data : null;
    } catch (error) {
      return null;
    }
  }

  function currencyCode() {
    const shopifyCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (shopifyCurrency) return shopifyCurrency;
    const product = readProduct();
    return product && product.currency;
  }

  function majorPrice(cents) {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return undefined;
    return Math.round(amount) / 100;
  }

  function selectedVariantId() {
    const forms = document.querySelectorAll('product-form-component');
    for (let index = 0; index < forms.length; index += 1) {
      const form = forms[index];
      if (form.closest('.quick-add')) continue;
      const input = form.querySelector('input[name="id"]');
      if (input && input.value) return input.value;
    }
    return '';
  }

  function findVariant(product, variantId) {
    const variants = product && Array.isArray(product.variants) ? product.variants : [];
    if (!variants.length) return null;
    if (variantId) {
      const match = variants.find((variant) => String(variant.variant_id) === String(variantId));
      if (match) return match;
    }
    return variants[0];
  }

  function productProperties(variantId) {
    const product = readProduct();
    if (!product) return {};
    const variant = findVariant(product, variantId);
    const properties = {
      product_id: product.product_id,
      product_handle: product.product_handle,
      product_title: product.product_title,
      currency: product.currency || currencyCode(),
      collection: product.collection,
    };
    if (variant) {
      properties.variant_id = variant.variant_id;
      properties.sku = variant.sku;
      const price = majorPrice(variant.price);
      if (price !== undefined) properties.price = price;
    }
    return properties;
  }

  function buttonLocation(element) {
    if (!element || !element.closest) return undefined;
    if (element.closest('[data-amada-contact-launcher]')) return 'contact_launcher';
    if (element.closest('[data-amada-high-value-enquiry]')) return 'high_value_enquiry';
    if (element.closest('.amada-aside')) return 'product_aside';
    if (element.closest('.amada-booking')) return 'booking';
    if (element.closest('header-component, #header-group, header')) return 'header';
    if (element.closest('#footer-group, footer')) return 'footer';
    const section = element.closest('[id^="shopify-section-"]');
    if (section && section.id) return section.id.replace(/^shopify-section-/, '');
    return 'page';
  }

  function isWhatsApp(href) {
    try {
      const host = new URL(href, window.location.origin).hostname.replace(/^www\./, '');
      return host === 'wa.me' || host === 'api.whatsapp.com' || host === 'whatsapp.com' || host.endsWith('.whatsapp.com');
    } catch (error) {
      return false;
    }
  }

  function isTelephone(href) {
    return href.trim().toLowerCase().startsWith('tel:');
  }

  function trackProductView() {
    if (productViewed) return;
    const product = readProduct();
    if (!product) return;
    productViewed = true;
    const context = productProperties(selectedVariantId());
    capture('product_viewed', Object.assign(pageContext(), context));
    // GBP threshold only; do not accidentally compare EUR/USD numerically as GBP.
    if (context.currency === 'GBP' && Number(context.price) >= 2000) {
      capture('high_value_product_view', Object.assign(pageContext(), context, {
        high_value_threshold_gbp: 2000
      }));
    }
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function requestMethod(input, init) {
    const method = (init && init.method) || (input && input.method) || 'GET';
    return String(method).toUpperCase();
  }

  function isCartAdd(url) {
    try {
      return /\/cart\/add(\.js)?$/.test(new URL(url, window.location.origin).pathname);
    } catch (error) {
      return false;
    }
  }

  function isEngravingFee(item) {
    if (!item || typeof item !== 'object') return false;
    if (item.handle === FEE_HANDLE) return true;
    const properties = item.properties;
    if (!properties) return false;
    if (properties._for) return true;
    if (Array.isArray(properties)) {
      return properties.some((entry) => entry && (entry.name === '_for' || entry[0] === '_for'));
    }
    return false;
  }

  function addedItems(data) {
    if (!data || typeof data !== 'object') return [];
    if (Array.isArray(data.items)) return data.items;
    if (data.variant_id || data.product_id) return [data];
    return [];
  }

  function trackAddedItem(item) {
    if (isEngravingFee(item)) return;
    const properties = pageContext();
    properties.product_id = item.product_id;
    properties.variant_id = item.variant_id;
    properties.product_handle = item.handle;
    properties.product_title = item.product_title || item.title;
    properties.sku = item.sku;
    const price = majorPrice(item.price);
    if (price !== undefined) properties.price = price;
    properties.currency = currencyCode();
    const quantity = Number(item.quantity);
    if (Number.isFinite(quantity) && quantity > 0) properties.quantity = quantity;
    const product = readProduct();
    if (product && String(product.product_id) === String(item.product_id)) {
      properties.collection = product.collection;
    }
    if (pendingAdd && Date.now() - pendingAdd.at < ADD_CONTEXT_MS) {
      properties.button_location = pendingAdd.location;
    }
    capture('add_to_cart', properties);
  }

  function inspectCartAdd(response) {
    let copy;
    try {
      copy = response.clone();
    } catch (error) {
      return;
    }
    copy
      .json()
      .then((data) => {
        if (!response.ok || !data || data.status) return;
        addedItems(data).forEach(trackAddedItem);
      })
      .catch(() => {});
  }

  function installCartAddTracking() {
    if (window.fetch.__amadaPosthogCart) return;
    const originalFetch = window.fetch.bind(window);
    const wrappedFetch = function amadaPosthogFetch(input, init) {
      const pending = originalFetch(input, init);
      if (requestMethod(input, init) !== 'POST' || !isCartAdd(requestUrl(input))) return pending;
      return pending.then((response) => {
        inspectCartAdd(response);
        return response;
      });
    };
    wrappedFetch.__amadaPosthogCart = true;
    window.fetch = wrappedFetch;
  }

  function rememberAddLocation(event) {
    if (!event.isTrusted) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const control = target.closest('button, a, input, [role="button"]');
    if (!control) return;
    let location = '';
    if (control.closest('sticky-add-to-cart')) location = 'sticky';
    else if (control.matches('[data-amada-add]') || control.closest('[data-amada-add]')) location = 'wishlist';
    else if (control.closest('.quick-add')) location = 'quick_add';
    else if (control.closest('product-form-component, form[action*="/cart/add"]')) location = 'product';
    if (!location) return;
    pendingAdd = { location, at: Date.now() };
  }

  function trackCommerceLinks(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const link = target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    console.info('[amada-posthog] link', href);

    if (isWhatsApp(href)) {
      console.info('[amada-posthog] whatsapp_click');
      capture(
        'whatsapp_click',
        Object.assign(pageContext(), productProperties(selectedVariantId()), {
          button_location: buttonLocation(link),
        })
      );
      return;
    }

    if (isTelephone(href)) {
      console.info('[amada-posthog] phone_click');
      capture(
        'phone_click',
        Object.assign(pageContext(), productProperties(selectedVariantId()), {
          button_location: buttonLocation(link),
        })
      );
    }
  }

  function trackClick(event) {
    if (!event.isTrusted) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    if (target.closest('[data-amada-contact-chat], [data-amada-contact-reply]')) {
      capture(
        'live_chat_open',
        Object.assign(pageContext(), productProperties(selectedVariantId()), {
          button_location: 'contact_launcher',
        })
      );
      return;
    }

    if (target.closest('[data-amada-enquiry-email]')) {
      capture(
        'enquiry_click',
        Object.assign(pageContext(), productProperties(selectedVariantId()), {
          enquiry_type: 'high_value_email',
          button_location: buttonLocation(target),
        })
      );
      return;
    }

    const submit = target.closest('button, input[type="submit"]');
    if (!submit) return;
    if (submit.closest('.email-signup, .email-signup__form')) return;

    if (submit.closest('.amada-hulk')) {
      capture(
        'enquiry_click',
        Object.assign(pageContext(), productProperties(selectedVariantId()), {
          enquiry_type: 'hulk',
          button_location: buttonLocation(submit),
        })
      );
      return;
    }

    if (submit.closest('form.contact-form__form') && !submit.closest('.amada-booking')) {
      capture(
        'enquiry_click',
        Object.assign(pageContext(), productProperties(selectedVariantId()), {
          enquiry_type: 'contact',
          button_location: buttonLocation(submit),
        })
      );
    }
  }

  function isReload() {
    const navigation = performance.getEntriesByType('navigation')[0];
    return Boolean(navigation && navigation.type === 'reload');
  }

  function trackServerSuccess() {
    if (isReload()) return;

    if (document.querySelector('.amada-booking__success')) {
      capture('appointment_booked', Object.assign(pageContext(), { booking_method: 'contact_fallback', button_location: 'booking' }));
    }

    document.querySelectorAll('.contact-form__success').forEach((node) => {
      if (node.closest('.amada-booking, .email-signup, .email-signup__form')) return;
      capture(
        'enquiry_submit',
        Object.assign(pageContext(), productProperties(selectedVariantId()), {
          enquiry_type: 'contact',
          button_location: buttonLocation(node),
        })
      );
    });
  }

  function trackHulkSuccess(event) {
    const root = event.target instanceof Element ? event.target : null;
    capture(
      'enquiry_submit',
      Object.assign(pageContext(), productProperties(selectedVariantId()), {
        enquiry_type: 'hulk',
        button_location: buttonLocation(root),
      })
    );
  }

  function trackCalendly(event) {
    if (event.origin !== 'https://calendly.com') return;
    const data = event.data;
    if (!data || data.event !== 'calendly.event_scheduled') return;
    const now = Date.now();
    if (now - lastCalendlyAt < 2000) return;
    lastCalendlyAt = now;
    capture('appointment_booked', Object.assign(pageContext(), { booking_method: 'calendly', button_location: 'booking' }));
  }

  // Detect genuine, consented attention across product pages in the same PostHog session.
  // Visible-but-idle tabs never accrue more than 30 seconds without activity.
  function installSeriousVisitorTracking() {
    // Five minutes of *elapsed* time while the page is open, including idle/background.
    // PostHog session and analytics consent are required; no timers without consent.
    const KEY = 'amada_elapsed_session_v1';
    const LIMIT_MS = 5 * 60 * 1000;
    let prior = null;
    try { prior = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (error) {}
    let sessionId = window.posthog?.get_session_id?.() || '';
    let elapsedMs = prior?.sessionId === sessionId && sessionId && Number.isFinite(prior?.elapsedMs)
      ? prior.elapsedMs : 0;
    let sent = Boolean(prior?.sessionId === sessionId && sessionId && prior?.sent);
    let lastTick = Date.now();

    function persist() {
      try { sessionStorage.setItem(KEY, JSON.stringify({ sessionId, elapsedMs, sent })); } catch (error) {}
    }
    function tick() {
      const now = Date.now();
      const delta = Math.max(0, now - lastTick);
      lastTick = now;
      if (!analyticsAllowed()) {
        elapsedMs = 0;
        sent = false;
        try { sessionStorage.removeItem(KEY); } catch (error) {}
        return;
      }
      const liveId = window.posthog?.get_session_id?.() || '';
      if (!liveId) return;
      if (liveId !== sessionId) { sessionId = liveId; elapsedMs = 0; sent = false; }
      // Count elapsed time regardless of visibility or interaction.
      elapsedMs += delta;
      if (!sent && elapsedMs >= LIMIT_MS) {
        sent = true;
        capture('high_intent_visitor', Object.assign(pageContext(), productProperties(selectedVariantId()), {
          event_reason: '5_minutes_elapsed_session',
          elapsed_session_seconds: Math.floor(elapsedMs / 1000),
          session_id: sessionId,
          page_title: document.title,
          current_url: window.location.href
        }));
      }
      persist();
    }
    window.addEventListener('pagehide', persist);
    window.setInterval(tick, 1000);
  }

  installCartAddTracking();  installSeriousVisitorTracking();
  document.addEventListener('click', trackCommerceLinks, true);
  document.addEventListener('click', rememberAddLocation, true);
  document.addEventListener('click', trackClick, true);
  document.addEventListener('amada:hulk:success', trackHulkSuccess);
  window.addEventListener('message', trackCalendly);
  trackProductView();
  trackServerSuccess();

  function persistPostHogIdentity() {
    if (!analyticsAllowed() || !window.posthog) return false;

    const distinctId = window.posthog.get_distinct_id?.();
    const sessionId = window.posthog.get_session_id?.();

    if (!distinctId) return false;

    const secure = location.protocol === 'https:' ? '; Secure' : '';

    document.cookie =
      `amada_ph_distinct_id=${encodeURIComponent(distinctId)}; Path=/; Max-Age=2592000; SameSite=Lax${secure}`;

    if (sessionId) {
      document.cookie =
        `amada_ph_session_id=${encodeURIComponent(sessionId)}; Path=/; Max-Age=86400; SameSite=Lax${secure}`;
    }

    return true;
  }

  if (!persistPostHogIdentity()) {
    let attempts = 0;

    const timer = setInterval(() => {
      attempts += 1;

      if (persistPostHogIdentity() || attempts >= 20) {
        clearInterval(timer);
      }
    }, 500);
  }
})();
